import { useDispatch } from "react-redux";
import { UIService, _ } from "src/services";
import { ConfigInitAction } from "src/store";

export const Offline: React.FC = () => {

    const loginParam = UIService.getLoginParam();
    const dispatch = useDispatch();

    const retry = () => {
        dispatch(ConfigInitAction.getData(loginParam));
    };

    return (
        <main className="offline">
            <div>
                <h3>{_("errorConnectingServer")}</h3>
                <span className="btn" onClick={retry}>{_("retry")}</span>
            </div>
        </main>
    );

};